import { apiCall, apiCallAdmin } from "../service/api-service";

const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const apiUrl = process.env.REACT_APP_API_URL;

// Helper to get admin API endpoint
const getAdminEndpoint = (endpoint) => {
  return endpoint.replace(apiUrl, "").replace(adminApiUrl, "");
};

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("GET", `get_org_image`);
  return response.data;
};

export const getProfileDetailsApi = async () => {
  return apiCallAdmin("GET", `basicprofile`);
};

export const updateProfileImageApi = async (data) => {
  return apiCallAdmin("POST", `user/image_update`, data);
};

export const reportAnIssueApi = async (data) => {
  return apiCallAdmin("POST", `report_issue`, data);
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("GET", `get_issue_type`);
  return response.data;
};

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("GET", `help?application=CRM`);
  return response.data;
};

export const getOrgListApi = async () => {
  return apiCallAdmin("GET", `get_enrolled_orgs`);
};

export const getSwitchAccountApi = async (id) => {
  const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";
  return await apiCallAdmin("GET", isHttpsOnly ? `switch_org_http_only/${id}` : `switch_org/${id}`);
};
